import { getIllustContainerName } from '../../../libs/illustStorage'

const V3_BASE_URL = 'https://object-storage.c3j1.conoha.io/v1/AUTH_5e55eda03e7a4bebacd7fa23722c486a'

export default (userId: number | string, illustId: number | string) => {
  if (import.meta.env.MODE === 'production') {
    const containerName = getIllustContainerName(illustId)
    return `${V3_BASE_URL}/${containerName}/illusts/${userId}/${illustId}.png`
  }
  return `/illusts/${userId}/${illustId}.png`
}
